export default Backbone.Model.extend({
    defaults: {
        isVisible: true,
        completed: false
    }
});
